export default __webpack_public_path__ + "static/media/man4.815b6a90.jpg";